import { contract, ContractEvents } from 'integrations/mixpanel/Events/contract';
import { timesheetHub, TimesheetHubEvents } from 'integrations/mixpanel/Events/timesheetHub';
import { expenseHub, ExpenseHubEvents } from 'integrations/mixpanel/Events/expenseHub';
import { invoiceHub, InvoiceHubEvents } from 'integrations/mixpanel/Events/invoiceHub';
import { workRequest, WorkRequestEvents } from 'integrations/mixpanel/Events/workRequest';
import { jobApplication, JobApplicationEvents } from 'integrations/mixpanel/Events/jobApplication';
import { MixpanelEvent } from '../MixPanelTypes';
import { dataTableFilters, DataTableFiltersEvents } from './dataTableFilters';
import { engagementHub, EngagementHubEvents } from './engagementHub';
import { frontdoor, FrontdoorEvents } from './frontdoor';
import { general, GeneralSettings } from './general';
import { dialog, DialogEvents } from './dialog';
import { MyContentExport, myContentExport } from './myContentExport';
import { notification, NotificationEvents } from './notifications';
import { org, OrgsEvents } from './orgs';
import { processDefinition, ProcessDefinitionEvents } from './processDefinitions';
import { quickReport, QuickReportsEvents } from './quickReports';
import { security, SecurityEvents } from './security';
import { sourcing, SourcingEvents } from './sourcing';
import { workerProfile, WorkerProfileEvents } from './workerProfile';
import { workers, WorkersEvents } from './workers';
import { supplier, SupplierEvents } from './supplier';
import { sourcingCandidate, SourcingCandidateEvents } from './sourcingCandidate';
import { reportTemplates, ReportTemplatesEvents } from './reportTemplates';
import { tenantConfiguration, TenantConfigurationEvents } from './tenantConfiguration';
import { myReports, MyReportsEvents } from './myReports';
import { standardReports, StandardReportsEvents } from './standardReports';
import { helpDocs, HelpDocsEvents } from './helpDocs';
import { BusinessEventEvents, businessEvents } from './businessEvents';
import { Widget, widget } from './widget';
import { QuickActionsEvents, quickActionsEvents } from './quickActions';
import { workerQualification, WorkerQualificationEvent } from './workerQualification';
import { supportLinks, SupportLinkEvents } from './clientSupportLinks';
import { importerEvents, ImporterEvents } from './importerEvents';
import { configItem, ConfigItemEvents } from './configItem';
import { smartFormEditor, SmartFormEditorEvents } from './smartFormEditor';
import {
  userInterfaceSettingsWorkerProfile,
  UserInterfaceSettingsWorkerProfileEvents
} from './userInterfaceSettingsWorkerProfile';
import { MilestoneEvents, milestone } from './milestone';
import { taskEvents, TaskEvents } from './taskEvents';
import { duplicateSearchEvents, DuplicateSearchEvents } from './duplicateSearchEvents';
import { addWorkerDuplicateSearchEvents, AddWorkerDuplicateSearchEvents } from './addWorkerDuplicateSearchEvents';
import { dailyBriefing, DailyBriefingEvents } from './dailyBriefing';

export interface MixpanelEventsMap {
  addWorkerDuplicateSearchEvents: Record<AddWorkerDuplicateSearchEvents, MixpanelEvent>;
  businessEvents: Record<BusinessEventEvents, MixpanelEvent>;
  configItem: Record<ConfigItemEvents, MixpanelEvent>;
  contract: Record<ContractEvents, MixpanelEvent>;
  dailyBriefing: Record<DailyBriefingEvents, MixpanelEvent>;
  dataTableFilters: Record<DataTableFiltersEvents, MixpanelEvent>;
  dialog: Record<DialogEvents, MixpanelEvent>;
  duplicateSearchEvents: Record<DuplicateSearchEvents, MixpanelEvent>;
  engagementHub: Record<EngagementHubEvents, MixpanelEvent>;
  expenseHub: Record<ExpenseHubEvents, MixpanelEvent>;
  frontdoor: Record<FrontdoorEvents, MixpanelEvent>;
  general: Record<GeneralSettings, MixpanelEvent>;
  helpDocs: Record<HelpDocsEvents, MixpanelEvent>;
  importerEvents: Record<ImporterEvents, MixpanelEvent>;
  invoiceHub: Record<InvoiceHubEvents, MixpanelEvent>;
  jobApplication: Record<JobApplicationEvents, MixpanelEvent>;
  myContentExport: Record<MyContentExport, MixpanelEvent>;
  myReports: Record<MyReportsEvents, MixpanelEvent>;
  notification: Record<NotificationEvents, MixpanelEvent>;
  org: Record<OrgsEvents, MixpanelEvent>;
  processDefinition: Record<ProcessDefinitionEvents, MixpanelEvent>;
  quickActionsEvents: Record<QuickActionsEvents, MixpanelEvent>;
  quickReport: Record<QuickReportsEvents, MixpanelEvent>;
  reportTemplates: Record<ReportTemplatesEvents, MixpanelEvent>;
  security: Record<SecurityEvents, MixpanelEvent>;
  smartFormEditor: Record<SmartFormEditorEvents, MixpanelEvent>;
  sourcing: Record<SourcingEvents, MixpanelEvent>;
  sourcingCandidate: Record<SourcingCandidateEvents, MixpanelEvent>;
  standardReports: Record<StandardReportsEvents, MixpanelEvent>;
  supplier: Record<SupplierEvents, MixpanelEvent>;
  supportLinks: Record<SupportLinkEvents, MixpanelEvent>;
  taskEvents: Record<TaskEvents, MixpanelEvent>;
  tenantConfiguration: Record<TenantConfigurationEvents, MixpanelEvent>;
  timesheetHub: Record<TimesheetHubEvents, MixpanelEvent>;
  userInterfaceSettingsWorkerProfile: Record<UserInterfaceSettingsWorkerProfileEvents, MixpanelEvent>;
  widget: Record<Widget, MixpanelEvent>;
  workRequest: Record<WorkRequestEvents, MixpanelEvent>;
  workerProfile: Record<WorkerProfileEvents, MixpanelEvent>;
  workerQualification: Record<WorkerQualificationEvent, MixpanelEvent>;
  workers: Record<WorkersEvents, MixpanelEvent>;
  milestone: Record<MilestoneEvents, MixpanelEvent>;
}

export const MixpanelEvents: MixpanelEventsMap = {
  addWorkerDuplicateSearchEvents,
  businessEvents,
  configItem,
  contract,
  dailyBriefing,
  dataTableFilters,
  dialog,
  duplicateSearchEvents,
  engagementHub,
  expenseHub,
  frontdoor,
  general,
  helpDocs,
  invoiceHub,
  importerEvents,
  jobApplication,
  myContentExport,
  myReports,
  notification,
  org,
  processDefinition,
  quickActionsEvents,
  quickReport,
  reportTemplates,
  security,
  sourcing,
  sourcingCandidate,
  smartFormEditor,
  standardReports,
  supplier,
  supportLinks,
  taskEvents,
  tenantConfiguration,
  timesheetHub,
  userInterfaceSettingsWorkerProfile,
  widget,
  workRequest,
  workerProfile,
  workerQualification,
  workers,
  milestone
};
